export function cls(...classnames: string[]) {
  return classnames.join(" ");
}
